import * as React from 'react';

import { LocalizedText } from 'bernie-l10n';

import { Options } from 'models';

import { classNames } from 'uitk-react-utils';

import {
  StrikeoutPriceAndInfoContainer,
  StrikeoutPriceAndInfoContainerProps,
} from 'components/common/pricing/strikeout-price-and-info-container';

export interface LeadAndSubPriceProps {
  option: Options;
  strikeoutDisclaimer?: string;
  dialogId?: string;
  handleClose?: () => void;
  wrapPrice?: boolean;
  dialogType?: string;
  priceFontWeight?: string;
  viewed?: boolean;
  label?: string;
  layerId?: string;
}

export const LeadAndSubPrice: React.FunctionComponent<LeadAndSubPriceProps> = ({
  label,
  option,
  viewed,
  strikeoutDisclaimer,
  dialogId,
  wrapPrice,
  dialogType,
}) => {
  if (!option) {
    return null;
  }
  const { displayPrice, loyaltyPrice, leadingCaption, disclaimer } = option;
  const loyaltyFontClass = displayPrice?.formatted ? 'loyalty-display-price' : 'loyalty-display-points';
  const price =
    (displayPrice && displayPrice.formatted) ||
    (loyaltyPrice &&
      loyaltyPrice.amount &&
      loyaltyPrice.amount.formatted &&
      loyaltyPrice.unit &&
      `${loyaltyPrice.amount.formatted} ${loyaltyPrice.unit}`) ||
    null;
  const strikeOut = loyaltyPrice?.totalStrikeOutPoints
    ? `${loyaltyPrice.totalStrikeOutPoints?.formatted} ${loyaltyPrice.unit}`
    : option?.strikeOut?.formatted;
  strikeoutDisclaimer = disclaimer?.value || strikeoutDisclaimer;
  const strikeoutInfo: StrikeoutPriceAndInfoContainerProps = {
    ...{
      strikeoutDisclaimer,
      strikeOut,
      dialogId,
      wrapPrice,
      dialogType,
    },
  };
  const testId = leadingCaption ? `content-hotel-secondary-price` : 'price-lockup-text';

  if (!price) {
    return strikeOut ? <StrikeoutPriceAndInfoContainer {...strikeoutInfo} /> : null;
  }
  const classes = leadingCaption
    ? classNames(`uitk-cell ${loyaltyFontClass}`, {
        'm-cell-shrink l-cell-shrink xl-cell-shrink': wrapPrice,
        'pwa-theme--grey-700': viewed,
      })
    : classNames(`uitk-cell ${loyaltyFontClass}`, {
        'all-cell-shrink': !wrapPrice,
        'm-cell-shrink l-cell-shrink xl-cell-shrink': wrapPrice,
        'pwa-theme--grey-700': viewed,
      });

  return (
    <>
      {strikeOut && <StrikeoutPriceAndInfoContainer {...strikeoutInfo} />}
      <span className={`${classes}`} data-stid="content-hotel-display-price">
        <span className="is-visually-hidden">
          <LocalizedText
            message={strikeOut ? 'hotels.infosite.rateInfoDialog.leadWithStrikeOutPresent' : 'hotels.infosite.rateInfoDialog.lead'}
            data={[price]}
          />
        </span>
        {leadingCaption && `${leadingCaption} `}
        <span className={`${classes}`} data-stid={testId} aria-hidden="true">
          {price}
        </span>
        {label && (
          <span className="uitk-type-400 uitk-type-regular pwa-theme--grey-900" data-stid="lead-price--text">
            {label}
          </span>
        )}
      </span>
    </>
  );
};
